<template>
  <project-settings-layout :id="id" :name="name">
    <el-card class="project-settings-custom-fields">
      <template #header>
        <h3>Custom Fields</h3>
      </template>
      <custom-fields-manager :id="id" entity-type="project" @name-loaded="name = $event" />
    </el-card>
  </project-settings-layout>
</template>

<script lang="ts">
/* General */
import { defineComponent } from 'vue'
import ProjectSettingsLayout from '@/layouts/project-settings-layout.vue'

export default defineComponent({
  name: 'ProjectSettingsCustomFields',

  components: {
    ProjectSettingsLayout,
  },

  data() {
    return {
      name: '',
    }
  },

  head(): any {
    return {
      title: `Custom Fields - ${this.name}`,
    }
  },

  computed: {
    id(): number {
      return parseInt(this.$route.params.id, 10)
    },
  },
})
</script>
